document.addEventListener('click', (event) => {
  document.querySelectorAll('.admin-v2-breadcrumbs details[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.admin-v2-breadcrumbs details[open]').forEach((details) => {
    const hasFocus = details.contains(document.activeElement);
    details.open = false;
    if (hasFocus) details.querySelector('summary').focus();
  });
});
